export default "__VITE_ASSET__DmYwZxdW__"